import { Button, H1, TextRegular } from "@hm/fundamental"
import NoTransactionFoundImage from "@shared/assets/no-transaction-found.svg"
import { useTraceparent } from "@shared/lib/hooks"
import { CentralizedContainerBox, TraceIdBadge } from "@shared/ui"
import React from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

export const NoTransactionFoundPage: React.FC = () => {
	const { t } = useTranslation("pages", { keyPrefix: "noTransactionFound" })
	const navigate = useNavigate()
	const { traceId } = useTraceparent()

	const handleNavigateToTransactions = () => {
		navigate("/transactions")
	}

	return (
		<CentralizedContainerBox data-cy="no-transaction-found-page-container">
			<div className="mx-auto flex max-w-[500px] flex-col items-center justify-center h-screen gap-6 py-12 px-6 text-center">
				<img
					src={NoTransactionFoundImage}
					alt="No transaction found"
					className="w-[240px] h-[154px]"
				/>
				<H1 className="text-foreground">{t("title")}</H1>
				<TextRegular className="text-foreground_faded">
					{t("description")}
				</TextRegular>
				<Button
					type="button"
					variant="primary"
					onClick={handleNavigateToTransactions}
					data-cy="navigate-to-transactions-button"
				>
					{t("secondaryButtonTitle")}
				</Button>
				<TraceIdBadge
					traceId={traceId}
					data-cy="no-transaction-found-trace-id"
				/>
			</div>
		</CentralizedContainerBox>
	)
}
